import { ParticleEmitterProperties } from "@lib/titan2/dist/game/control/properties/ParticleEmitterProperties";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import { Point } from "pixi.js";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { GameStyle } from "../../../style/GameStyle";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { GameFontStyle } from "../../../style/GameFontStyle";
import { GameLang } from "../../../lang/GameLang";
export class FeaturePurpleFishProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    setDefaultValues() {
        this.setBubbleParticles();
        this.setSparkleParticles();
        this.background = new SpriteProperties("FatCatBackground", "Game", new Point(0, -448));
        this.cat = new SpineProperties("FatCat", "Game", new Point(973, 512), new Point(1, 1));
        this.boxLeft = new SpineProperties("FatCatBox", "Game", new Point(973, 512), new Point(1, 1)),
            this.boxMiddle = new SpineProperties("FatCatBox", "Game", new Point(973, 512), new Point(1, 1)),
            this.boxRight = new SpineProperties("FatCatBox", "Game", new Point(973, 512), new Point(1, 1)),
            this.boxItems = [
                new SpriteProperties("prop_watch", "Game", new Point(0, 0), new Point(1, 1), new Point(0.5, 0.8)),
                new SpriteProperties("prop_snuffbox_fatcat", "Game", new Point(0, 0), new Point(1, 1), new Point(0.5, 0.8)),
                new SpriteProperties("prop_hairclip", "Game", new Point(0, 0), new Point(1, 1), new Point(0.5, 0.8)),
                new SpriteProperties("prop_tuna", "Game", new Point(0, 0), new Point(1, 1), new Point(0.5, 0.8)),
                new SpriteProperties("prop_necklace", "Game", new Point(0, 0), new Point(1, 1), new Point(0.5, 0.8))
            ];
        this.furball = new SpineProperties("Furball", "Game", new Point(0, 0), new Point(1, 1));
        this.furballText = new TextFieldProperties(GameFontStyle.FEATURE_PURPLE_FISH_DIGIT, new Point(0, -110), null, ControlConstants.CENTER, ControlConstants.CENTER, new Point(220, 220));
        this.sparkleParticles.position = new Point(0, 0);
        this.bubbleParticlesPrize.position = new Point(0, 0);
        this.bubbleParticlesLeft.position = new Point(0, 512);
        this.bubbleParticlesRight.position = new Point(1946, 512);
        this.lightBurstProperties = new SpriteProperties("lightBurst", GameStyle.MODULE, new Point(0, 0), null, new Point(0.5, 0.5));
        this.heartProperties = new SpriteProperties("heart", GameStyle.MODULE, new Point(0, 0), null, new Point(0.5, 0.5));
        const fishScale = new Point(0.13, 0.13);
        this.fish = {
            green: new SpineProperties("FishGreen", "Game", null, fishScale),
            purple: new SpineProperties("FishPurple", "Game", null, fishScale),
            gold: new SpineProperties("FishGold", "Game", null, fishScale),
            blue: new SpineProperties("FishBlue", "Game", null, fishScale),
            red: new SpineProperties("FishRed", "Game", null, fishScale),
        };
        this.logoProperties = new SpriteProperties(GameStyle.LOGO, GameStyle.MODULE, new Point(1385, 83), new Point(0.73, 0.73), new Point(0, 0));
        this.bowl = new SpineProperties("Bowl", "Game", new Point(973, 512), new Point(0.75, 0.75));
        this.bubble = new SpineProperties("BubblePick", "Game");
        this.bubbleLocations = [
            new Point(-252, -65),
            new Point(-5, -132),
            new Point(248, -30),
        ];
        this.bubbleIcons = [
            new SpriteProperties("RedFishChest", GameStyle.MODULE, new Point(0, 0), new Point(0.8, 0.8), new Point(0.5, 0.5)),
            new SpriteProperties("RedFishCastle", GameStyle.MODULE, new Point(0, 0), new Point(0.8, 0.8), new Point(0.5, 0.5)),
            new SpriteProperties("RedFishClam", GameStyle.MODULE, new Point(0, 0), new Point(0.8, 0.8), new Point(0.5, 0.5)),
        ];
        this.idleFishRangeX = [-620, +620];
        this.idleFishRangeY = [-770, -545];
        this.offscreenPositions = {
            green: new Point(-620, -755),
            red: new Point(620, -755),
            gold: new Point(-620, -485),
            blue: new Point(620, -485),
        };
        this.waitPositions = {
            green: new Point(-330, -755),
            red: new Point(330, -755),
            gold: new Point(-375, -485),
            blue: new Point(375, -485),
        };
        this.pickedPrize = new TextFieldProperties(GameFontStyle.FEATURE_PURPLE_FISH_PICKED_PRIZE, new Point(0, -110), null, ControlConstants.CENTER, ControlConstants.CENTER, new Point(220, 220));
        this.missedPrize = new TextFieldProperties(GameFontStyle.FEATURE_PURPLE_FISH_MISSED_PRIZE, new Point(0, -75), null, ControlConstants.CENTER, ControlConstants.CENTER, new Point(160, 150));
        this.numberPrize = new TextFieldProperties(GameFontStyle.FEATURE_PURPLE_FISH_DIGIT, new Point(0, -75), null, ControlConstants.CENTER, ControlConstants.CENTER, new Point(160, 150));
        this.finalBubbleXText = new TextFieldProperties(GameFontStyle.FEATURE_PURPLE_FISH_PICKED_PRIZE, new Point(0, 3), null, ControlConstants.CENTER, ControlConstants.CENTER, new Point(160, 150));
        this.finalBubbleXText.scale.set(0.6);
        this.finalBubbleMultiplierText = new TextFieldProperties(GameFontStyle.FEATURE_PURPLE_FISH_PICKED_PRIZE, new Point(0, 30), null, ControlConstants.CENTER, ControlConstants.CENTER, new Point(160, 150));
        this.pickedPrize.fontProperties.letterSpacing = -2;
        this.pickedPrize.fontProperties.trim = this.missedPrize.fontProperties.trim = true;
        this.titleText = new TextFieldProperties(GameFontStyle.FEATURE_TITLE, new Point(973, 50), GameLang.BONUS_LABEL3, ControlConstants.CENTER, ControlConstants.CENTER, new Point(800, 200));
        this.helpText = new TextFieldProperties(GameFontStyle.FEATURE_HELP_TEXT, new Point(973, 475), GameLang.BONUS_PROMPT2, ControlConstants.CENTER, ControlConstants.CENTER, new Point(800, 200));
        this.titleText.scale.set(0.8);
        this.helpText.scale.set(0.8);
        this.titleText.visible = false;
    }
    setBubbleParticles() {
        this.bubbleParticlesPrize = new ParticleEmitterProperties();
        this.bubbleParticlesLeft = new ParticleEmitterProperties();
        this.bubbleParticlesRight = new ParticleEmitterProperties();
        const config = {
            autoUpdate: true,
            frequency: 0.02,
            maxParticles: 1000,
            pos: {
                x: 0,
                y: 0,
            },
            lifetime: {
                min: 2.5,
                max: 3
            },
            emitterLifetime: 0.3,
            addAtBack: false,
            behaviors: [
                {
                    "type": "textureSingle",
                    "config": {
                        "texture": "particles/particleBubble"
                    }
                },
                {
                    type: 'spawnShape',
                    config: {
                        type: 'rect',
                        data: {
                            x: 0,
                            y: 0,
                            w: 0,
                            h: 0,
                        }
                    }
                },
                {
                    "type": "rotationStatic",
                    "config": {
                        "min": 180,
                        "max": 360,
                    }
                }, {
                    type: 'moveAcceleration',
                    config: {
                        accel: {
                            x: 0,
                            y: -500,
                        },
                        minStart: 500,
                        maxStart: 1000,
                    },
                },
                {
                    "type": "noRotation",
                    "config": {
                        "rotation": 0
                    }
                },
                {
                    type: 'scaleStatic',
                    config: {
                        min: 0.5,
                        max: 1.5,
                    }
                },
                {
                    type: 'alpha',
                    config: {
                        alpha: {
                            list: [{ value: 0, time: 0 }, { value: 0.75, time: 0.1 }, { value: 0.2, time: 0.8 }, { value: 0, time: 1 }]
                        },
                    }
                },
            ]
        };
        this.bubbleParticlesPrize.config = config;
        this.bubbleParticlesLeft.config = config;
        this.bubbleParticlesRight.config = config;
    }
    setSparkleParticles() {
        this.sparkleParticles = new ParticleEmitterProperties();
        this.sparkleParticles.config = {
            autoUpdate: true,
            frequency: 0.02,
            maxParticles: 1000,
            pos: {
                x: 0,
                y: 0,
            },
            lifetime: {
                min: 0.4,
                max: 0.7
            },
            emitterLifetime: 0.5,
            addAtBack: false,
            behaviors: [
                {
                    "type": "textureSingle",
                    "config": {
                        "texture": "particles/particleSparkle"
                    }
                },
                {
                    type: 'blendMode',
                    config: {
                        blendMode: "add",
                    }
                },
                {
                    type: 'spawnShape',
                    config: {
                        type: 'rect',
                        data: {
                            x: 0,
                            y: 0,
                            w: 0,
                            h: 0,
                        }
                    }
                },
                {
                    type: 'moveSpeedStatic',
                    config: {
                        min: 600,
                        max: 800
                    }
                },
                {
                    "type": "rotationStatic",
                    "config": {
                        "min": 0,
                        "max": 360,
                    }
                },
                {
                    "type": "noRotation",
                    "config": {
                        "rotation": 0
                    }
                },
                {
                    type: 'scaleStatic',
                    config: {
                        min: 0.25,
                        max: 1.5,
                    }
                },
                {
                    type: 'alpha',
                    config: {
                        alpha: {
                            list: [{ value: 0, time: 0 }, { value: 0.75, time: 0.1 }, { value: 0.75, time: 0.8 }, { value: 0, time: 1 }]
                        },
                    }
                },
            ]
        };
    }
}
//# sourceMappingURL=FeaturePurpleFishProperties.js.map